import { GetAccount200ResponsePositionsInner } from "../../codegen-api";
import { IBaseModalProps } from "../BaseModal";

export interface IClosePositionModal extends IBaseModalProps {
  position?: GetAccount200ResponsePositionsInner;
}

export const Tpsl = {
  Price: "USD",
  Roi: "%ROI",
} as const;

export type TpslType = typeof Tpsl[keyof typeof Tpsl];

/** Everything `renderTpslForm` needs. Lives here to keep the render file lean. */
export interface RenderTpslFormProps {
  position: any;
  errors: any;
  handleSubmit: any;
  onConfirmTPSLForPosition: () => void;
  tpPriceRegister: any;
  lastEditedTp: any;
  tpType: TpslType;
  setTpType: (t: TpslType) => void;
  tpGainRegister: any;
  tpDropdownOpen: boolean;
  setTpDropdownOpen: (b: boolean) => void;
  actualTpTriggerPrice: any;
  pricePrecision: number;
  amountPrecision: number;
  /** The market's size step; the close-size % buttons floor onto it. */
  amountStep?: number;
  takeProfitExpectedPnl: any;
  slPriceRegister: any;
  lastEditedSl: any;
  slType: TpslType;
  setSlType: (t: TpslType) => void;
  slLossRegister: any;
  slDropdownOpen: boolean;
  setSlDropdownOpen: (b: boolean) => void;
  actualSlTriggerPrice: any;
  stopLossExpectedPnl: any;
  /** State + toggles for the two checkboxes and the trigger-source selector. */
  advanced: any;
  closeSizeRegister: any;
  tpLimitPriceRegister: any;
  slLimitPriceRegister: any;
  asset: string;
  markPrice?: string | number;
  indexPrice?: number;
  lastPrice?: number;
  t: (key: string, options?: any) => string;
  errorMessage: string | undefined;
}
